/**
 * @license The MIT License (MIT)
 * @copyright Stanislav Kalashnik <darkpark.main@gmail.com>
 */

'use strict';

var Component = require('../component');


/**
 *
 * @constructor
 * @extends Component
 *
 * @param {Object} [config={}] - init parameters (all inherited from the parent)
 */
function List ( config ) {
    var self = this,
        $node;

    console.assert(typeof this === 'object', 'must be constructed via new');
    console.assert(typeof config === 'object', 'wrong config type');

    config.focusable = true;

    // parent constructor call
    Component.call(this, config);

    // shortcut
    $node = this.$node;

    Object.defineProperties(this, {

    });

    // custom visualization
    config.render && (this.render = config.render);

    // apply and render
    this.data = config.data;

    $node.addEventListener('click', function ( event ) {
        var $item = event.target;

        // find the top item
        while ( $item.parentNode !== $node ) {
            $item = $item.parentNode;
        }

        // notify listeners
        self.events.click && self.emit('click', /*data[$item.dataset.index],*/ event);

        // listeners can cancel focusing
        if ( !event.defaultPrevented ) {
            self.$focusItem = $item;
        }
    });

    $node.addEventListener('wheel', () => {
        console.log('wheel');

        this.$node.classList.add('list--scrolled');
        clearTimeout(this.private.scrollTimeout);
        this.private.scrollTimeout = setTimeout(() => {
            this.$node.classList.remove('list--scrolled');
        }, 2000);
    });
}


// inheritance
List.prototype = Object.create(Component.prototype);
List.prototype.constructor = List;

// set component name
List.prototype.name = 'list';


Object.defineProperties(List.prototype, {
    data: {
        get: function () {
            return this.private.data;
        },
        set: function ( data ) {
            var $node     = this.$node,
                $fragment = document.createDocumentFragment(),
                internals = this.private;

            // sanitize
            data = data || [];

            // valid input
            if ( Array.isArray(data) ) {
                // notify listeners
                this.events.data && this.emit('data', data, internals.data);
                // store
                internals.data = data;

                // clear container
                while ( $node.lastChild ) {
                    $node.removeChild($node.lastChild);
                }

                // reset focus states
                internals.focusIndex = internals.$focusItem = null;

                // create items
                data.forEach(function ( dataItem, index ) {
                    var $item = document.createElement('div');

                    // build item
                    $item.dataset.index = index;
                    $item.className = this.name + '__item';
                    this.render($item, dataItem);

                    $fragment.appendChild($item);
                }, this);

                // fill
                $node.appendChild($fragment);
            } else {
                console.error('wrong data type', data);
            }
        }
    },

    $focusItem: {
        get: function () {
            return this.private.$focusItem;
        },
        set: function ( $value ) {
            var internals  = this.private,
                $focusItem = internals.$focusItem,
                focusIndex = internals.focusIndex,
                itemClass  = this.name + '__item--focused';

            // valid focus candidate or null to clear focus
            if ( ($value && $value.parentNode === this.$node) || !$value ) {
                // nothing has changed
                if ( $value === $focusItem ) {
                    console.warn('$focusItem: current and new values are identical', $value, this);
                } else {
                    // the previous focused element
                    if ( $focusItem ) {
                        // clear
                        $focusItem.classList.remove(itemClass);
                        // notify listeners
                        this.events['blur:item'] && this.emit('blur:item', internals.data[focusIndex], $focusItem, focusIndex);
                    }

                    // store
                    internals.$focusItem = $focusItem = $value || null;
                    internals.focusIndex = focusIndex = $focusItem ? Number($focusItem.dataset.index) : null;

                    // new selection
                    if ( $focusItem ) {
                        // apply styles
                        $focusItem.classList.add(itemClass);
                        // notify listeners
                        this.events['focus:item'] && this.emit('focus:item', internals.data[focusIndex], $focusItem, focusIndex);
                    }
                }
            } else {
                console.error('$focusItem should be a child element of $node', $value);
            }
        }
    },

    focusIndex: {
        get: function () {
            return this.private.focusIndex;
        },
        set: function ( value ) {
            var internals = this.private,
                $target;

            if ( value === null || value === undefined ) {
                // reset
                this.$focusItem = null;
            } else {
                // sanitize
                value = Number(value);

                // nothing has changed
                if ( internals.focusIndex === value ) {
                    console.warn('focusIndex: current and new values are identical', value, this);
                } else {
                    // valid input
                    if ( value >= 0 && value < internals.data.length ) {
                        // find the element to focus
                        $target = this.$node.children[value];
                        // apply
                        this.$focusItem = $target;
                    } else {
                        console.error('focusIndex is out of range', value);
                    }
                }
            }
        }
    }
});


/**
 * Method to build each list item content.
 *
 * @param {Element} $item - item DOM link
 * @param {*} data - associated with this item data
 */
List.prototype.render = function ( $item, data ) {
    $item.textContent = data;
};


// public
module.exports = List;
